import React, { useState,useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import ClassRoomUnit from "../components/classes/ClassRoomUnit";
import {LoginAfterCheckLogin} from "../../components/common/Common";

import "../../css/style.css";

//비밀번호 찾기
const SetClassroom = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const navigate = useNavigate();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varMCRList,setMCRList] = useState([]);
  const [varFCRList,setFCRList] = useState([]);

  //교실호출
  const GetClassRoomList = async() => {
    const sendData = {branch_idx:branch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_classroom_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //마마몽뗴교실
        const m_classArray = datas.classroom_m;
        setMCRList(m_classArray);
        //플라이교실
        const f_classArray = datas.classroom_f;
        setFCRList(f_classArray);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    GetClassRoomList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //교실 선택 유무
  const onChangeCRHandler = (e,cr_name) => {
    const bchecked = e.currentTarget.checked;
    console.log(cr_name);
    if(cr_name[0] === 'M') {  //마마몽떼 
      const copyList = [...varMCRList];
      let findIndex = copyList.findIndex(el=>el.cr_name === cr_name);
      if(bchecked) {  //선택
        if(copyList[findIndex]['cr_status']===1) { //추가
          copyList[findIndex]['cr_status'] = 2;
          setMCRList(copyList);
        } 
      } else {
        if(copyList[findIndex]['cr_status']===2) { //제외
          copyList[findIndex]['cr_status'] = 1;
          setMCRList(copyList);
        } 
      }
    } else {  //플라이
      const copyList = [...varFCRList];
      let findIndex = copyList.findIndex(el=>el.cr_name === cr_name);
      if(bchecked) {  //선택
        if(copyList[findIndex]['cr_status']===1) { //추가
          copyList[findIndex]['cr_status'] = 2;
          setFCRList(copyList);
        } 
      } else {
        if(copyList[findIndex]['cr_status']===2) { //제외
          copyList[findIndex]['cr_status'] = 1;
          setFCRList(copyList);
        } 
      }
    }
  }

  //저장하기
  const onUpdateClassRoomHandler = async(e) => {
    if(!window.confirm('설정된 교실 정보를 저장합니까?')) return false;

    const sendData = {mList:varMCRList,fList:varFCRList};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_classroom_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigate('/Branch/Setting');
      } else {
        alert(datas.message);
      }
    });
  }

  return (
    <div className="vh-content cl-room-setting-wrap">
      <HeaderBranchTitle varPageTitle={'교실 설정'} varBackString={'/Branch/Setting'}/>
      <div className="vh-content-body">
        <div className="center-wrap">
          <div className="cl-room-con"> 
            <div className="con-box">
              <p>마마몽떼 교실 설정</p>
              <div className="chk-box-wrap" id="mamamonte_classroom">
                {varMCRList.map((mclass,i)=>(
                  <ClassRoomUnit key={'mclass_'+i} varCRItem={mclass} onChangeCRHandler={onChangeCRHandler}/>
                ))}
              </div>
            </div>
            <div className="con-box">
              <p>플라이 교실 설정</p>
              <div className="chk-box-wrap" id="fly_classroom">
                {varFCRList.map((fclass,i)=>(
                  <ClassRoomUnit key={'fclass_'+i} varCRItem={fclass} onChangeCRHandler={onChangeCRHandler}/>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="form-contoller bt-btn">
					<Link to="/Branch/Setting" className="form-contoller-btn btn-no" style={{width:"48%"}}>취소</Link>
					<button className="form-contoller-btn btn-yes" onClick={e=>onUpdateClassRoomHandler(e)}>확인</button>
				</div>
      </div>	
    </div>	
  );
}
export default SetClassroom;